var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rich-text-editor"},[_c('span',{staticClass:"rich-text-editor__label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('VueEditor',{ref:"editor",class:{
      error: _vm.isError,
      'single-line': _vm.isSingleLine,
      'm-disabled': _vm.isDisabled,
    },attrs:{"placeholder":_vm.placeholder,"editor-toolbar":_vm.toolbar,"disabled":_vm.isDisabled},on:{"selection-change":_vm.handleSelectionChange},model:{value:(_vm.innerValue),callback:function ($$v) {_vm.innerValue=$$v},expression:"innerValue"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }